"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("../../stylesheets/components/common/Pagination.css");

var _reactPaginate = _interopRequireDefault(require("react-paginate"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is just a wrapper component so that the css is automatically included.
var _default = function _default(props) {
  return /*#__PURE__*/_react.default.createElement(_reactPaginate.default, props);
};

exports.default = _default;